import React from "react";
import PropTypes from "prop-types";
import { MyDraggable as Draggable } from "../components/Core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { l, setPalette } from "../functions";
import GKEvent from "../events";
import axios from "axios";
import { ajaxUri } from "../consts/index";
import { HighlightSharp } from "@material-ui/icons";

class Block extends React.Component {
  constructor(props) {
    super(props);
  }

  _removeBlock = () => {
    axios({
      method: "post",
      url: ajaxUri,
      data: {
        request: "removeBlock",
        path: this.props.path,
      },
    })
      .then((result) => {
        GKEvent.notification(result.data.status, result.data.message);

        if (result.data.status === "success") {
          this.setState(this.defaultState);

          axios({
            method: "post",
            url: ajaxUri,
            data: {
              request: "listBlocks",
            },
          })
            .then((result) => {
              const tabs = result.data;
              setPalette(tabs);
            })
            .catch((error) => {});
        }
      })
      .catch((error) => {
        GKEvent.notification(
          "error",
          l("Error while deleting the block. Please try again.")
        );
      });
  };

  _getName = () => {
    let { id } = this.props;

    id = id.replace("block_", "");
    id = id.replace(/_/g, " ");
    return id;
  };

  render() {
    const {
      dropzoneID,
      parentID,
      showBasicContent,
      showPreview,
      id,
      dropzoneProps,
      payload,
      options,
      tabId,
      ...rest
    } = this.props;

    if (showBasicContent && tabId !== "designed_blocks") {
      return (
        <Draggable {...this.props} side={true}>
          <div>
            <img src={rest.img} />
            {/* <h3>{this._getName()}</h3> */}
            {this.props.deletable && (
              <button
                onClick={() => {
                  this._removeBlock();
                }}
                className="delete"
              >
                <FontAwesomeIcon icon={["fal", "trash-alt"]} />
              </button>
            )}
          </div>
        </Draggable>
      );
    } else if (tabId === "designed_blocks") {
      return (
        <Draggable {...this.props} side={true}>
          <div className="my-block">
            {/* <img src={rest.img} /> */}
            <h3>{this._getName()}</h3>
            {this.props.deletable && (
              <button
                onClick={() => {
                  this._removeBlock();
                }}
                className="delete"
              >
                <FontAwesomeIcon icon={["fal", "trash-alt"]} />
              </button>
            )}
          </div>
        </Draggable>
      );
    }

    return <div></div>;
  }
}

Block.propTypes = {
  id: PropTypes.string.isRequired,
  showBasicContent: PropTypes.bool.isRequired,
};

export default Block;
